window.defaultThemeConfig = {
    color: '#8AC754',
    lightFont: "'OpenSansLight', 'Arial', 'Verdana', 'Sans-serif'",
    regularFont: "'Open Sans Hebrew', 'OpenSansRegular', 'Arial', 'Verdana', 'Sans-serif'"
};